// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomScroller_surface__kzJny {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CustomScroller_container__9Bq9- {
  /* border: 2px solid black; */
  overflow: hidden;
  position: relative;
  border-radius: 20px 20px 20px 20px;
  height: 200px;
  width: 100%;
  /* background-image: linear-gradient(
    transparent,
    transparent 40%,
    var(--focused-input-color); 34%,
    var(--focused-input-color); 60%,
    transparent 59%,
    transparent
  ); */
}
.CustomScroller_tableSearchContainer__tAdfq {
  background-image: linear-gradient(
    transparent,
    transparent 40%,
    #eaecff 34%,
    #eaecff 60%,
    transparent 59%,
    transparent
  );
}
.CustomScroller_container__9Bq9-::after {
  content: "";
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  background-image: linear-gradient(
    #ffffff,
    rgba(245, 245, 245, 0) 40%,
    rgba(245, 245, 245, 0) 50%,
    #ffffff
  );
}
.CustomScroller_wheel__d4985 {
  position: absolute;
  height: 40px;
  top: 50%;
  margin-top: -20px;
  width: 100%;
  border-top: 1px var(--focused-input-color) solid;
  border-bottom: 1px var(--focused-input-color) solid;
}
.CustomScroller_numbersContainer__ugyZa {
  width: 100%;
  padding: 0;
}

.CustomScroller_item__q-KMA {
  height: 40px;
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 40px;
  width: 100%;
  text-align: center;
  transition: all 200ms ease;
}
.CustomScroller_frontDrop__R3TAn {
  position: fixed;
  width: 100%;
  height: 100vh;
  top: 0;
  right: 0;
  z-index: 999999;
  background-color: transparent;
}
.CustomScroller_boldItem__7Mdi9 {
  font-size: 18px;
  font-weight: 500;
}
.CustomScroller_littleXroate__7G1zi {
  transform: rotateX(30deg);
}
.CustomScroller_littleXXroate__XyKK\\+ {
  transform: rotateX(45deg);
}
.CustomScroller_littleXXUproate__R43cc {
  transform: rotateX(-30deg);
}
.CustomScroller_littleXUproate__T7UC- {
  transform: rotateX(-45deg);
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/CustomScroller/CustomScroller.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,WAAW;EACX;;;;;;;MAOI;AACN;AACA;EACE;;;;;;;GAOC;AACH;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;EAUpB;;;;;GAKC;AACH;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,gDAAgD;EAChD,mDAAmD;AACrD;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EAEzB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,MAAM;EACN,QAAQ;EACR,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".surface {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.container {\r\n  /* border: 2px solid black; */\r\n  overflow: hidden;\r\n  position: relative;\r\n  border-radius: 20px 20px 20px 20px;\r\n  height: 200px;\r\n  width: 100%;\r\n  /* background-image: linear-gradient(\r\n    transparent,\r\n    transparent 40%,\r\n    var(--focused-input-color); 34%,\r\n    var(--focused-input-color); 60%,\r\n    transparent 59%,\r\n    transparent\r\n  ); */\r\n}\r\n.tableSearchContainer {\r\n  background-image: linear-gradient(\r\n    transparent,\r\n    transparent 40%,\r\n    #eaecff 34%,\r\n    #eaecff 60%,\r\n    transparent 59%,\r\n    transparent\r\n  );\r\n}\r\n.container::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  z-index: 2;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  pointer-events: none;\r\n  background-image: -webkit-gradient(\r\n    linear,\r\n    left top,\r\n    left bottom,\r\n    from(#f5f5f5),\r\n    color-stop(52%, rgba(245, 245, 245, 0)),\r\n    color-stop(48%, rgba(245, 245, 245, 0)),\r\n    to(#f5f5f5)\r\n  );\r\n  background-image: linear-gradient(\r\n    #ffffff,\r\n    rgba(245, 245, 245, 0) 40%,\r\n    rgba(245, 245, 245, 0) 50%,\r\n    #ffffff\r\n  );\r\n}\r\n.wheel {\r\n  position: absolute;\r\n  height: 40px;\r\n  top: 50%;\r\n  margin-top: -20px;\r\n  width: 100%;\r\n  border-top: 1px var(--focused-input-color) solid;\r\n  border-bottom: 1px var(--focused-input-color) solid;\r\n}\r\n.numbersContainer {\r\n  width: 100%;\r\n  padding: 0;\r\n}\r\n\r\n.item {\r\n  height: 40px;\r\n  cursor: default;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  line-height: 40px;\r\n  width: 100%;\r\n  text-align: center;\r\n  transition: all 200ms ease;\r\n}\r\n.frontDrop {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100vh;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 999999;\r\n  background-color: transparent;\r\n}\r\n.boldItem {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n}\r\n.littleXroate {\r\n  transform: rotateX(30deg);\r\n}\r\n.littleXXroate {\r\n  transform: rotateX(45deg);\r\n}\r\n.littleXXUproate {\r\n  transform: rotateX(-30deg);\r\n}\r\n.littleXUproate {\r\n  transform: rotateX(-45deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"surface": `CustomScroller_surface__kzJny`,
	"container": `CustomScroller_container__9Bq9-`,
	"tableSearchContainer": `CustomScroller_tableSearchContainer__tAdfq`,
	"wheel": `CustomScroller_wheel__d4985`,
	"numbersContainer": `CustomScroller_numbersContainer__ugyZa`,
	"item": `CustomScroller_item__q-KMA`,
	"frontDrop": `CustomScroller_frontDrop__R3TAn`,
	"boldItem": `CustomScroller_boldItem__7Mdi9`,
	"littleXroate": `CustomScroller_littleXroate__7G1zi`,
	"littleXXroate": `CustomScroller_littleXXroate__XyKK+`,
	"littleXXUproate": `CustomScroller_littleXXUproate__R43cc`,
	"littleXUproate": `CustomScroller_littleXUproate__T7UC-`
};
export default ___CSS_LOADER_EXPORT___;
